// extracted by mini-css-extract-plugin
module.exports = {"textSection":"Galeria_textSection__3F72M","section":"Galeria_section__2Esg0","titleBold":"Galeria_titleBold__2HZ8G","mainHeader":"Galeria_mainHeader__2-DU_"};